import { supabase } from './supabase';

export interface ModerationResult {
  isAcceptable: boolean;
  violations?: string[];
  reason?: string;
  scores?: Record<string, number>;
  context?: string;
  metadata?: {
    thresholds: Record<string, number>;
    contextType: string;
    timestamp: string;
  };
}

export async function moderateContent(
  text: string,
  context: 'default' | 'family' | 'professional' = 'default'
): Promise<ModerationResult> {
  if (!text?.trim()) {
    return { isAcceptable: true };
  }

  try {
    const response = await fetch('https://quote-moderation-api.onrender.com/moderate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ text, context })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return {
      isAcceptable: data.isAcceptable,
      violations: data.violations,
      scores: data.scores,
      context: data.context,
      metadata: data.metadata
    };
  } catch (error) {
    console.error('Content moderation error:', error);
    return {
      isAcceptable: true, // Fail open to prevent blocking legitimate content
      reason: 'Moderation service unavailable'
    };
  }
}